<template>
  <div>
    <a class="hiddenanchor" id="signup"></a>
    <a class="hiddenanchor" id="signin"></a>

    <div class="login_wrapper">
      <div class="animate form login_form">
        <section class="login_content">
          <c-form @submit="login">
            <h1>Đăng nhập</h1>

            <c-input label="Username"
                     label-invisible
                     validate-rules="required"
                     v-model="username"
            />

            <c-input label="Mật khẩu"
                     label-invisible
                     type="password"
                     validate-rules="required"
                     v-model="password"
            />

            <div>
              <button class="btn btn-default" type="submit">Đăng nhập</button>
              <a class="reset_pass" href="#">Lost your password?</a>
            </div>

            <div class="clearfix"></div>

            <!--            <div class="separator">-->
            <!--              <p class="change_link">New to site?-->
            <!--                <a href="#signup" class="to_register"> Create Account </a>-->
            <!--              </p>-->

            <!--              <div class="clearfix"></div>-->
            <!--              <br />-->

            <!--              <div>-->
            <!--                <h1><i class="fa fa-paw"></i> Gentelella Alela!</h1>-->
            <!--                <p>©2016 All Rights Reserved. Gentelella Alela! is a Bootstrap 3 template. Privacy and Terms</p>-->
            <!--              </div>-->
            <!--            </div>-->
          </c-form>
        </section>
      </div>

      <div id="register" class="animate form registration_form">
        <section class="login_content">
          <form>
            <h1>Create Account</h1>
            <div>
              <input type="text" class="form-control" placeholder="Username" required=""/>
            </div>
            <div>
              <input type="email" class="form-control" placeholder="Email" required=""/>
            </div>
            <div>
              <input type="password" class="form-control" placeholder="Password" required=""/>
            </div>
            <div>
              <a class="btn btn-default submit" href="index.html">Submit</a>
            </div>

            <div class="clearfix"></div>

            <div class="separator">
              <p class="change_link">Already a member ?
                <a href="#signin" class="to_register"> Log in </a>
              </p>

              <div class="clearfix"></div>
              <br/>

              <div>
                <h1><i class="fa fa-paw"></i> Gentelella Alela!</h1>
                <p>©2016 All Rights Reserved. Gentelella Alela! is a Bootstrap 3 template. Privacy and Terms</p>
              </div>
            </div>
          </form>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  mounted() {
    $('body').removeClass()
             .addClass('login');
  },
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    login() {
      this.$http.post("/auth", {username: this.username, password: this.password})
          .then(response => {
            this.$cookies.set("token", response.headers.authorization, Number(response.headers.expires));
            this.$cookies.set("username", response.headers.username, Number(response.headers.expires));
            $.ajaxSetup({
              headers: {
                "Authorization": response.headers.authorization
              },
            });
            this.$router.push(this.$route.query.nextUrl || "/");
          }, error => {

          })
    },
  }
}
</script>

<style scoped>

</style>